import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const CreateWarehouseComponent = loadable(
  () => import("../../components/Warehouse/CreateWarehouse")
);
const CreateWarehouse = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["warehouse"],
    navigateURL: "/warehouse",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.WAREHOUSE}`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.primary_contact}`,
      "secondary_contact":values?.secondary_contact? `+977${values?.secondary_contact}`: `+977${values?.mobile_number}`
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">
          Create Warehouse
        </span>
      </div>
      <CreateWarehouseComponent
      isLoading={isPostLoading}
       handleCreate={handleCreate}
        />
    </>
  );
};
export default CreateWarehouse;
